var t={container:"EmptyState-module_container__nz4PQ",description:"EmptyState-module_description__-LJrG"};export{t as default};
//# sourceMappingURL=EmptyState.module.scss.js.map
